import type { CreativeLabelDefinition } from '../models/labelSchema.types'

import { canonicalLabelType, labelValueOptions } from './labelSchema'

export type LabelEditorKind = 'dropdown' | 'text' | 'readonly'

export interface LabelEditOption {
  value: string
  label: string
}

export function labelEditorKind(
  definition: Pick<CreativeLabelDefinition, 'type'>,
): LabelEditorKind {
  const type = canonicalLabelType(definition.type)
  if (type === 'yesno' || type === 'multiple') return 'dropdown'
  if (type === 'text') return 'text'
  return 'readonly'
}

export function isLabelEditable(definition: Pick<CreativeLabelDefinition, 'type'>): boolean {
  return labelEditorKind(definition) !== 'readonly'
}

export function yesNoEditOptions(
  definition: Pick<CreativeLabelDefinition, 'display'>,
  copy: { trueText: string; falseText: string },
): LabelEditOption[] {
  return [
    { value: 'true', label: definition.display?.true_text ?? copy.trueText },
    { value: 'false', label: definition.display?.false_text ?? copy.falseText },
  ]
}

export function multipleEditOptions(definition: CreativeLabelDefinition): LabelEditOption[] {
  return labelValueOptions(definition).map((option) => ({
    value: option.value,
    label: option.display_name,
  }))
}

export function fromWireValue(
  definition: Pick<CreativeLabelDefinition, 'type'>,
  value: unknown,
): string {
  const type = canonicalLabelType(definition.type)
  if (type === 'yesno') return value === true || value === 'true' ? 'true' : 'false'
  return value === null || value === undefined ? '' : String(value)
}

export function toWireValue(
  definition: Pick<CreativeLabelDefinition, 'type'>,
  draft: string,
): unknown {
  return canonicalLabelType(definition.type) === 'yesno' ? draft === 'true' : draft
}

export function isSameLabelValue(
  definition: Pick<CreativeLabelDefinition, 'type'>,
  a: unknown,
  b: unknown,
): boolean {
  return fromWireValue(definition, a) === fromWireValue(definition, b)
}
